import { AppDispatch } from '../../store'
import { FsOFAOverall, FsOFAValue, Run } from '../../../shared/model/models'
import { analysisActions } from '../../reducers/analysis'

export const changeCurrentRun = (run: Run | null) => (dispatch: AppDispatch) => {
  dispatch(analysisActions.setCurrentRun(run))
}

export const changeOFAOverall =
  (contextModelVariantId: number, data: FsOFAOverall) => (dispatch: AppDispatch) => {
    dispatch(analysisActions.setOFAOverall({ contextModelVariantId, data }))
  }

export const changeOFAValues =
  (contextModelVariantId: number, data: FsOFAValue[]) => (dispatch: AppDispatch) => {
    dispatch(analysisActions.setOFAValues({ contextModelVariantId, data }))
  }

export const setOFATrainingCost = (cost: number) => (dispatch: AppDispatch) => {
  dispatch(analysisActions.setOFATrainingCost(cost))
}

export const updateCurrentFairViewTab = (tab: string) => (dispatch: AppDispatch) => {
  dispatch(analysisActions.setCurrentFairViewTab(tab))
}

export * from './thunk'
